import React from 'react';
import {CaretUpFilled} from "@ant-design/icons";

const Dot = ({ color, padding = 'px-1', size = 16, Icon = CaretUpFilled,
               label = null, fontWeight='500', labelSize=12, fillIcon=false }) => {
  const style = {
    fontSize: size,
    color: color,
    marginRight: label ? '8px' : '0', // Add some space between the dot and the label if the label is present
  };
  const labelStyle = {
    fontFamily: 'var(--font-title)',
    fontWeight: fontWeight,
  }


  return (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <Icon style={{ color: color, fontSize: size, paddingRight: '4px', }} size={size} fill={fillIcon?color:'transparent'} />
      {label && <span style={{ fontSize: labelSize, ...labelStyle }}>{label}</span>}
    </span>
  );
};

export default Dot;
